// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3oQdd","info":"UpdateTermsInfo_info__2S4yM"};